// extracted by mini-css-extract-plugin
export default {"operation":"LayoutsTable_operation__SDvI6","avatar":"LayoutsTable_avatar__kfLlO","table":"LayoutsTable_table__nmJCo","date":"LayoutsTable_date__xwSr1"};